import { FC } from 'react'
import { Box } from '@mui/material'
import PageHeading from 'components/atoms/PageHeading'
import { useTranslation } from 'react-i18next'
import BenchmarkTrackerSetupForm from 'components/organisms/forms/BenchmarkTrackerSetupForm'

const BenchmarkTrackerSetupPage: FC<{}> = () => {

  const { t } = useTranslation()

  return (
    <Box px={2}>

      <PageHeading title={t('common.benchmark-tracker')} />
      <Box sx={{padding: '30px'}} mb={3}><BenchmarkTrackerSetupForm /></Box>

    </Box>
  )
}
export default BenchmarkTrackerSetupPage
